import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { JobApplication } from '../../../providers/api/dtos';
import { getJobApplication } from '../../../providers/api/job-application/jobApplicationProvider';

export const JOB_APPLICATION_RID = '/v2/job-applications';

export function useJobApplication(
  jobApplicationId?: string,
  options?: SWRConfiguration<JobApplication, AxiosError>,
): SWRResponse<JobApplication, AxiosError> {
  return useSWR(
    jobApplicationId ? [JOB_APPLICATION_RID, jobApplicationId] : null,
    () => getJobApplication(jobApplicationId!),
    options,
  );
}
